import { AnalyticsEventData } from "@/analytics";

export enum NavigationSourceEnum {
    FEATURED_PAGE = 'featured_page'
}

export type NavigationAnalyticsType = {
    navigationSource: NavigationSourceEnum;
    supportingData?: AnalyticsEventData;
} 